@if (form.signed) {
    @if (hasSignaturePreview) {
        <div class="distribution_camera_signature reactive-form-signature-wrapper">
            <div>
                <div class="reactive-form-signature-column">
                    <p>Firma</p>
                    <img
                        alt="Firma"
                        [src]="signatureSrc"
                        class="info-firma-img"
                        (load)="onSignatureImageLoad()"
                        (error)="onSignatureImageError()" />
                </div>
            </div>
        </div>
    }

    @if (form.type < 3) {
        <app-signature
            (sendFile)="signatureFile.emit($event)"
            (sendTempImg)="signatureTempImage.emit($event)">
        </app-signature>
    }
}
